module.exports = __webpack_public_path__ + "img/dinamond.68b1d347.svg";